import { useCallback, useDeferredValue, useState } from "react";

import { computeFromDate, Interval, INTERVAL_CONFIG, isoYesterday } from "./utils";

export const useAnalyticsFilters = () => {
  const [interval, setInterval] = useState<Interval>(Interval.D7);
  const [dateFrom, setDateFrom] = useState(computeFromDate(Interval.D7));
  const [dateTo, setDateTo] = useState(isoYesterday());
  const [granularity, setGranularity] = useState(INTERVAL_CONFIG[Interval.D7].granularity);
  const deferredFrom = useDeferredValue(dateFrom);
  const deferredTo = useDeferredValue(dateTo);

  const handleIntervalChange = useCallback((newInterval: Interval) => {
    setInterval(newInterval);
    if (newInterval !== Interval.Custom) {
      setDateFrom(computeFromDate(newInterval));
      setDateTo(isoYesterday());
      setGranularity(INTERVAL_CONFIG[newInterval].granularity);
    }
  }, []);

  return {
    interval,
    dateFrom,
    dateTo,
    granularity,
    deferredFrom,
    deferredTo,
    setDateFrom,
    setDateTo,
    setGranularity,
    handleIntervalChange,
  };
};
